import script from "./DiagnosticsView.vue?vue&type=script&setup=true&lang=js"
export * from "./DiagnosticsView.vue?vue&type=script&setup=true&lang=js"

import "./DiagnosticsView.vue?vue&type=style&index=0&id=05d24e31&lang=scss&scoped=true"

import exportComponent from "/home/dev/g-nti/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05d24e31"]])

export default __exports__